import React from 'react';

// --- Import Sponsor Logos ---
import KornhaberLogo from '../assets/Kornhaber Dental.png';
import GibcoLogo from '../assets/Gibco Logo.png';
import KerboomKidzLogo from '../assets/Ker-Boom-Kids-Logo.png';
import JillBermanLogo from '../assets/Jill Berman Logo.png';
import StudioYALogo from '../assets/Studio Y&A Logo.jpg';
import RubyAndJennaLogo from '../assets/RubyAndJennaLogo.jpg';
import RXFitLogo from '../assets/RX Fit.png';
import PosterSignsLogo from '../assets/Poster Signs Logo.png';

// Function to generate the Instagram URL from the handle (without the '@')
const getInstagramUrl = (handle) => {
    return handle ? `https://www.instagram.com/${handle.replace('@', '')}/` : null;
};

// Reusable component for a single sponsor card
const SponsorCard = ({ tier, name, websiteLink, instagramHandle, large = false, logoSrc }) => {
  
  const instagramUrl = getInstagramUrl(instagramHandle);
  const hasWebsite = !!websiteLink;
  const hasInstagram = !!instagramUrl;

  const renderSocialLinks = () => {
    // Case 4: Neither
    if (!hasWebsite && !hasInstagram) {
      if (name === "Jill Berman") {
        return <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>Individual Sponsor</p>;
      }
      return null;
    }

    // Case 3: Both Website and Instagram
    if (hasWebsite && hasInstagram) {
      return (
        <p style={{ margin: 0, fontSize: '0.9rem', color: '#666', display: 'flex', gap: '5px', justifyContent: 'center' }}>
          <a href={websiteLink} target="_blank" rel="noopener noreferrer">Website</a>
          {' | '}
          <a href={instagramUrl} target="_blank" rel="noopener noreferrer">Instagram: {instagramHandle}</a>
        </p>
      );
    }
    
    // Case 1: Just Website
    if (hasWebsite) {
      return (
        <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
          <a href={websiteLink} target="_blank" rel="noopener noreferrer">Website</a>
        </p>
      );
    }

    // Case 2: Just Instagram
    if (hasInstagram) {
      return (
        <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
          <a href={instagramUrl} target="_blank" rel="noopener noreferrer">Instagram: {instagramHandle}</a>
        </p>
      );
    }
    
    return null;
  };
  
  const nameElement = <h3 style={{ margin: '10px 0 5px 0' }}>{name}</h3>;

  return (
    <div className={`sponsor-card ${tier}`} style={tier === 'gold' ? { maxWidth: '1200px', width: '100%' } : {}}>
      <div className={`sponsor-logo-placeholder ${tier}`} style={tier === 'gold' ? { maxWidth: '600px', height: '375px' } : {}}>
        {logoSrc ? (
          <img 
            src={logoSrc} 
            alt={`${name} Logo`} 
            style={{ 
              maxWidth: '100%', 
              maxHeight: '100%', 
              objectFit: 'contain',
              borderRadius: '8px'
            }} 
          />
        ) : (
          `${name} Logo Placeholder`
        )}
      </div>
      {nameElement}
      {renderSocialLinks()}
    </div>
  );
};

const SponsorsPage = () => {
  return (
    <div className="sponsors-container">
      <h2>Our Generous Sponsors</h2>

      {/* --- GOLD SPONSORS --- */}
      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ color: 'gold', textShadow: '1px 1px 2px #000' }}>Gold Sponsors</h2>
        <div className="sponsor-grid">
          <SponsorCard 
            tier="gold" 
            name="Kornhaber Dental Group" 
            websiteLink="https://www.kornhaberdg.com/" 
            instagramHandle="@kornhaberdentalgroup"
            large={true}
            logoSrc={KornhaberLogo}
          />
          <SponsorCard 
            tier="gold" 
            name="Gibco Construction" 
            websiteLink="https://www.GibcoNY.com" 
            instagramHandle="@Gibco.Construction"
            large={true}
            logoSrc={GibcoLogo}
          />
        </div>
      </section>

      {/* --- BRONZE SPONSORS --- */}
      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ color: '#CD7F32' }}>Bronze Sponsors</h2>
        <div className="sponsor-grid">
          <SponsorCard 
            tier="bronze" 
            name="Jill Berman" 
            websiteLink="https://www.elliman.com/agent/jill-berman/1027447"
            instagramHandle="@jillbermanrealtor"
            logoSrc={JillBermanLogo}
          />
          <SponsorCard 
            tier="bronze" 
            name="Studio Y&A Architecture Design" 
            websiteLink="https://www.studioyadesign.com/"
            instagramHandle="@studioyadesignny"
            logoSrc={StudioYALogo}
          />
          <SponsorCard 
            tier="bronze" 
            name="Ruby and Jenna" 
            websiteLink="https://rubyandjenna.com"
            instagramHandle="@rubyandjenna"
            logoSrc={RubyAndJennaLogo}
          />
        </div>
      </section>

      {/* --- EVENT SPONSORS --- */}
      <section style={{ marginBottom: '40px' }}>
        <h2>Event Sponsors</h2>
        <div className="sponsor-grid">
          <SponsorCard 
            tier="event" 
            name="RX Fit" 
            websiteLink="https://www.rxfit.us/"
            instagramHandle="@werxfit"
            logoSrc={RXFitLogo}
          />
          <SponsorCard 
            tier="event" 
            name="Kerboom Kidz" 
            websiteLink="https://kerboomkidz.com/home/"
            instagramHandle="@kerboomkidz"
            logoSrc={KerboomKidzLogo}
          />
        </div>
      </section>

      {/* --- SIGNAGE SPONSORS --- */}
      <section style={{ marginBottom: '40px' }}>
        <h2>Signage Sponsors</h2>
        <div className="sponsor-grid">
          <SponsorCard 
            tier="event" 
            name="Poster Signs" 
            websiteLink="https://www.postersigns.com"
            instagramHandle="@postersigns"
            logoSrc={PosterSignsLogo}
          />
        </div>
      </section>

      <p style={{ fontSize: '0.9rem', color: '#555', marginTop: '-0.5rem', marginBottom: '0rem' }}>
        If you would like to become a sponsor please email: manorhavenschoolpta@gmail.com
      </p>

    </div>
  );
};

export default SponsorsPage;